var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meal-card-manage"},[_c('statistics',{attrs:{"isMealCard":true}}),_c('file-list',{attrs:{"isMealCard":true}}),_c('edit-modal',{attrs:{"isMealCard":true}}),_c('delete-modal'),_c('card-detail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }